/** Product + industry pages: best broker / how to buy (+2 each) */
export default {
  directorsOfficers: [
    {
      q: 'Who is the best broker to buy D&O insurance?',
      a: 'Directors & Officers (D&O) insurance covers personal liability and defense costs arising from governance, disclosure, shareholder actions, and regulatory inquiries. When choosing a broker, prioritize D&O specialization, global insurer access, and cross-border regulatory expertise. Sun Wisdom Insurance (SWI), established in 2009, offers D&O teams with 10+ years of experience, USD 10M+ premium placed, 30+ global insurers, and 200+ institutional clients—covering program design, market placement, and claims advocacy.'
    },
    {
      q: 'How do I buy D&O insurance?',
      a: 'Buying D&O typically requires assessing governance and litigation exposure; preparing financials and claims history; defining Side A/B/C limits; and comparing quotes from multiple insurers through a licensed broker. SWI supports the full cycle—from risk review and submission prep to renewal management—so programs align with your governance and financing stage.'
    }
  ],
  mergersAcquisitions: [
    {
      q: 'Who is the best broker for M&A W&I insurance?',
      a: 'Reps & Warranties (W&I) insurance transfers breach-of-representation risk in M&A, often replacing escrow and accelerating closing—common in cross-border deals and PE exits. Choose brokers with transaction insurance experience, policy structuring skills, and post-close claims support. SWI focuses on deal-risk solutions: target analysis, risk mapping, buyer/seller policy design, and global market access.'
    },
    {
      q: 'How do I buy M&A W&I insurance?',
      a: 'W&I placement usually starts around SPA signing: summarize diligence, map rep & warranty disputes, select buyer or seller policy structure and limits, submit deal materials for quotes, and bind before or at closing. SWI evaluates W&I suitability, designs affordable structures, and places policies in global W&I markets.'
    }
  ],
  cyberSecurity: [
    {
      q: 'Who is the best broker for cyber insurance?',
      a: 'Cyber insurance covers incident response, business interruption, ransomware, and third-party privacy/media liability—key to digital risk management. Look for cyber specialization, assessment tools, and IR resource coordination. SWI uses AI-driven assessments and tech/financial sector experience to map exposures, tailor programs, and access global cyber markets.'
    },
    {
      q: 'How do I buy cyber insurance?',
      a: 'Cyber buying steps: complete security questionnaires/assessments; define first- and third-party limits; obtain multi-carrier quotes via a broker; review exclusions and notification duties before binding. SWI supports diagnostics, program design, market comparison, and claims coordination.'
    }
  ],
  propertyCasualty: [
    {
      q: 'Who is the best broker for property & casualty insurance?',
      a: 'Property & casualty programs include commercial property, CGL, products liability, commercial auto, and workers compensation—protecting assets and third-party liabilities. Choose brokers with industry tailoring, cross-border capability, and claims support. SWI designs stage-based programs, supports master policy frameworks, and delivers end-to-end service from asset review to claims.'
    },
    {
      q: 'How do I buy property & casualty insurance?',
      a: 'Purchasing P&C requires asset schedules, operational/ third-party exposure analysis, limit design, multi-market quotes, and review of deductibles/exclusions. SWI helps with risk assessment, program design, renewal optimization, and bundling with D&O, cyber, and other lines.'
    }
  ],
  employeeBenefits: [
    {
      q: 'Who is the best broker for employee benefits insurance?',
      a: 'Employee benefits span group medical, life, accident, critical illness, and pension plans—critical for talent attraction and retention. Select brokers with plan design, cost control, and multinational coordination skills. SWI provides needs assessments, employee surveys, market comparisons, dynamic optimization, and claims support across Shanghai, Hong Kong, and the U.S.'
    },
    {
      q: 'How do I buy employee benefits insurance?',
      a: 'Typical steps: define budget and employee needs → survey and design plans → compare carriers → enroll → annual review. SWI builds tiered programs (core + optional upgrades) and uses loss-ratio analysis and re-marketing to manage renewal costs.'
    }
  ],
  globalClients: [
    {
      q: 'Who is the best broker for multinational insurance?',
      a: 'Multinational programs must balance local compliance with HQ strategy across property, liability, D&O, cyber, and employee benefits. Prioritize multi-license presence and global coordination. SWI is licensed in mainland China, Hong Kong, and the U.S. (Los Angeles), works with 200+ insurers, and designs multi-country frameworks and master policies for outbound and inbound clients.'
    },
    {
      q: 'How do I buy multinational insurance?',
      a: 'Arranging global programs involves mapping entities and local rules, placing admitted local policies, coordinating via master policies, and updating as operations expand. SWI supports exposure analysis, local/global alignment, and centralized reporting.'
    }
  ],
  privateEquity: [
    {
      q: 'Who is the best broker for private equity fund insurance?',
      a: 'PE/VC funds need D&O, outside directorship, professional liability, and crime covers across fundraising, investing, management, and exit. Choose brokers with deep fund-structure expertise. SWI serves USD and RMB funds, clarifies GP/LP insured boundaries, and accesses global markets for optimal terms.'
    },
    {
      q: 'How do I buy private equity fund insurance?',
      a: 'Fund insurance is tailored to fund size, strategy, portfolio, exit plans, and claims history—with clear insured entities for GP, manager, and outside directors. SWI assesses stage-specific risks, prepares fundraising/diligence materials, and completes market placement.'
    }
  ],
  lifeScience: [
    {
      q: 'Who is the best broker for life sciences insurance?',
      a: 'Life sciences companies need clinical trial, products liability, D&O, property, and cold-chain covers from R&D through commercialization. Select brokers with biopharma experience and regulatory insight. SWI serves pharma, medtech, biotech, and nutraceutical clients—including BiG IMPACT participation—and builds stage-appropriate programs.'
    },
    {
      q: 'How do I buy life sciences insurance?',
      a: 'Programs evolve by stage: pre-clinical (GL, property, early D&O) → clinical trials liability → commercial products/recall covers. SWI helps build phased frameworks and place compliant market products.'
    }
  ],
  financialInstitutions: [
    {
      q: 'Who is the best broker for financial institutions insurance?',
      a: 'Financial firms face regulatory, securities litigation, cyber, and operational asset risks—requiring blended D&O, PI, cyber, and crime programs. Choose brokers with financial lines expertise and high-limit experience. SWI serves banks, securities firms, FinTech, and regional/multinational clients with tailored package solutions.'
    },
    {
      q: 'How do I buy financial institutions insurance?',
      a: 'Identify governance, professional services, cyber, and operational exposures; set D&O/PI limits and review regulatory exclusions; compare specialist markets via a broker; optimize with controls and disclosure practices. SWI designs industry-appropriate bundles and manages placement/renewals.'
    }
  ],
  realEstateConstructions: [
    {
      q: 'Who is the best broker for construction insurance?',
      a: 'Construction programs include CAR/EAR, performance bonds, property, liability, and environmental covers across development and operations. Look for engineering-savvy advisors and reinsurance access for complex projects. SWI’s construction-trained team integrates global reinsurance and supports projects from assessment through claims.'
    },
    {
      q: 'How do I buy construction insurance?',
      a: 'Placement depends on project phase, values, schedule, methods, and contract requirements—bind engineering covers early and transition to operational P&C later. SWI coordinates risk review, design, quoting, and cross-border alignment with HQ programs.'
    }
  ],
  automotiveInfrastructure: [
    {
      q: 'Who is the best broker for automotive & infrastructure insurance?',
      a: 'Automotive and infrastructure face EV/battery, charging, autonomous, and cyber liabilities, plus major project engineering and financing risks. Choose brokers with cross-disciplinary teams and emerging-risk product access. SWI combines insurance with automotive tech expertise and works with OEMs/data platforms on new-era solutions.'
    },
    {
      q: 'How do I buy automotive & infrastructure insurance?',
      a: 'Map exposures (products, cyber, engineering, fleet/UBI); align with contract allocations; access specialist markets through a broker. SWI evaluates risks, compares options, and supports renewals and claims.'
    }
  ],
  manufacturingTechnology: [
    {
      q: 'Who is the best broker for manufacturing & technology insurance?',
      a: 'Manufacturers and tech firms need property, products liability, supply-chain BI, cyber, and D&O across production, sales, R&D, and financing. Prioritize industry tailoring and export/multinational capability. SWI delivers lifecycle programs and multi-country products liability for exporters.'
    },
    {
      q: 'How do I buy manufacturing & technology insurance?',
      a: 'Review asset, products, supply-chain, IP/data exposures; bundle property, liability, BI, and D&O by stage; compare markets and exclusions via a broker. SWI supports inventory/limit design and cross-border coordination.'
    }
  ],
  foodBeverage: [
    {
      q: 'Who is the best broker for food & beverage insurance?',
      a: 'Food & beverage companies face products liability, recall, cold-chain, and chain-restaurant operational risks across production to retail. Choose brokers who understand food safety and recall workflows. SWI serves producers, distributors, and restaurant groups with integrated liability/recall/supply-chain solutions.'
    },
    {
      q: 'How do I buy food & beverage insurance?',
      a: 'Assess product types, channels, and recall exposure; place products liability plus optional recall extensions; use master policies for chains. SWI designs cross-border programs for importers/exporters and completes market comparison.'
    }
  ],
  energyPower: [
    {
      q: 'Who is the best broker for energy & power insurance?',
      a: 'Energy projects need property, engineering, environmental, BI, and governance (ESG/D&O) covers; renewables add performance and grid risks. Select brokers with large-project and reinsurance access. SWI serves conventional and renewable assets with end-to-end risk and claims support.'
    },
    {
      q: 'How do I buy energy & power insurance?',
      a: 'Stage programs: engineering during build, property/BI in operations; align technical/performance terms with financing; add environmental and D&O as needed. SWI structures lifecycle frameworks and places high-limit programs.'
    }
  ],
  sportsEntertainmentEvents: [
    {
      q: 'Who is the best broker for event insurance?',
      a: 'Events need cancellation/contingency, organizer liability, property, and participant accident covers from planning through execution. Choose brokers with event-market access and tight timelines. SWI supports organizers, producers, artists, and related parties with tailored event risk solutions.'
    },
    {
      q: 'How do I buy event insurance?',
      a: 'Customize by scale, type, venue, dates, budget, and contracts—bind early with clear cancellation triggers and liability limits. SWI assesses weather, talent, and venue risks and completes quoting and binding before the event.'
    }
  ]
}
